import { createAction } from '@reduxjs/toolkit';

import { SET_BROWSER_LANGUAGE, type BrowserLanguage } from './types';

export const setBrowserLanguage = createAction<BrowserLanguage, typeof SET_BROWSER_LANGUAGE>(
	SET_BROWSER_LANGUAGE,
);
